import React from 'react';
import PropTypes from 'prop-types';

import ContactSelect from './select';
import ContactFormModal from 'bundles/backoffice/contacts/forms/modal';

export default class ContactSelector extends React.Component {
  static propTypes = {
    allowTagging: PropTypes.bool,
    className: PropTypes.string,
    contact: PropTypes.object,
    contactType: PropTypes.string,
    disabled: PropTypes.bool,
    menuPlacement: PropTypes.string,
    modalBackdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    multipleBusinesses: PropTypes.bool,
    newContactFormSections: PropTypes.node,
    newContactVisibility: PropTypes.string,
    requestPermissions: PropTypes.bool,
    styles: PropTypes.object,
    validateNewContactFormSections: PropTypes.func,
    onChange: PropTypes.func.isRequired
  }

  state = {}

  showCreateContactModal = () => {
    this.setState({ showCreateContactModal: true });
  }

  hideCreateContactModal = () => {
    this.setState({ showCreateContactModal: false });
  }

  handleModalSave = (contact) => {
    this.handleChange(contact, true);
  }

  handleSelectChange = (contact) => {
    this.handleChange(contact, false);
  }

  handleChange = (contact, newContact) => {
    if (contact && !contact.id) {
      contact.id = contact.associatedModelId;
    }

    if (contact && !contact.contactType) {
      contact.contactType = contact.associatedModelType;
    }

    this.props.onChange(contact, newContact);
    this.hideCreateContactModal();
  }

  render() {
    return <>
      <ContactSelect
        className={this.props.className}
        contact={this.props.contact}
        disabled={this.props.disabled}
        limitToType={this.props.contactType}
        menuPlacement={this.props.menuPlacement}
        styles={this.props.styles}
        onChange={this.handleSelectChange}
        onCreateClick={this.showCreateContactModal}
      />

      <ContactFormModal
        allowTagging={this.props.allowTagging}
        backdrop={this.props.modalBackdrop}
        contactType={this.props.contactType}
        extraFormSections={this.props.newContactFormSections}
        multipleBusinesses={this.props.multipleBusinesses}
        newContactVisibility={this.props.newContactVisibility}
        requestPermissions={this.props.requestPermissions}
        show={this.state.showCreateContactModal}
        validateExtraSections={this.props.validateNewContactFormSections}
        onCancel={this.hideCreateContactModal}
        onSave={this.handleModalSave}
      />
    </>;
  }
}
